import React from 'react'

export default function Alert(props) {
  return (

    // props.alert &&  <div className="alert alert-warning alert-dismissible fade show" role="alert">
    
    props.alert &&  <div className={`alert alert-${props.alert.type} alert-dismissible fade show`} role="alert">
  {/* <strong>Holy guacamole!</strong> You should check in on some of those fields below. */}
  <strong>{props.alert.type}</strong> :  {props.alert.msg}
  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>
   
  )
}


// this happens because all the jsx will be converted to js calls!